import { gql } from '@apollo/client';
/**
 * @const GetOperaRoomTypeAvailabilityQuery
 * @since 1.0.0
 */
export const GetOperaRoomTypeAvailabilityQuery = gql `
  query GetOperaRoomTypeAvailability($input: GetOperaRoomTypeAvailabilityInput!) {
    getOperaRoomTypeAvailability(input: $input) {
      categoryAvailabilities {
        categoryId
        categoryName
        availabilities
      }
      timeUnitStartsUtc
    }
  }
`;
